import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './SidingAccent.module.css';

/**
 * Siding Accent Step Component
 * Applies color to Siding_Edge surface.
 */
export default function SidingAccent({ 
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedColor, setSelectedColor] = useState(null);

    // Selection key: StepName_Room
    const selectionKey = `SidingAccent_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedColor(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleColorSelect = (product) => {
        setSelectedColor(product);
        
        console.log('SidingAccent - Color selected:', product.color || product.name);
        
        // Store selection in Redux
        dispatch(selectProduct({
            product,
            surfaceName: 'Siding Accent',
            stepIndex,
            selectionKey
        }));

        // Apply the color
        applyColor(product);
    };

    const applyColor = (color) => {
        const chamViz = document.getElementById('chamViz');
        if (!chamViz) {
            console.error('SidingAccent - chamViz element not found');
            return;
        }

        if (!color.id) {
            console.error('SidingAccent - Color has no ID');
            return;
        }

        console.log('SidingAccent - Applying color:', color.id);
        console.log('SidingAccent - Applying to surfaces: Siding Accent, Siding Accent 2');
        
        dispatch(setVizLoading(true));
        
        chamViz.applyByFilter(
            color.id,
            "",
            function(newSel) {
                // this = surface object { name, type, sortorder, sel }
                if (this.name === 'Siding Accent' || this.name === 'Siding Accent 2') {
                    return newSel;
                }
                return this.sel;
            },
            true
        );
    };

    const handleViewAllApplied = () => {
        if (onViewAllApplied) {
            onViewAllApplied();
        }
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Siding Accent"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={handleViewAllApplied}
            />

            {/* Product List - Colors */}
            <div className={styles.productListContainer}>
                <ProductList
                    seriesId="9707"
                    thumbSize="256"
                    onProductSelect={handleColorSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedColor?.id}
                />
            </div>
        </div>
    );
}

SidingAccent.propTypes = {
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
